// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dSL97","icon":"styles_icon__3fqcB"};